import React, { useEffect, useLayoutEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import strings from "translate/language";
import Breadcrumb from "component/common/breadcrumb";
import {
  handleListResponse,
  minORmaxAmountEmiValid,
  minORmaxAmountValid,
  seo,
  minORmaxValid
} from "utils/utils";
import { bulkVerifyVisitForm } from "../../reduxStore/action/visitorActions";
import { getConfigurationPropList } from "../../reduxStore/action/propertyActions";
import moment from "moment";
import { getConfiguration } from "reduxStore/action/masterActions";

const CreateLeadNext = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({});
  const [formVaild, setFormVaild] = useState(null);
  const [propertyConfig, setPropertyConfig] = useState([]);
  const dispatch = useDispatch();
  const [viewData, setViewData] = useState({});
  const params = useParams();
  const { _id = "" } = params || {};
  const lead_id = new URLSearchParams(window.location.search).get("lead_id");

  const navigatpage = async (navname) => {
    navigate(navname);
  };
  const [configurationsType, setConfigurationsType] = useState([]);
  const configurationsSelector =
    useSelector((state) => state.configurations) || {};

  const { response = {} } =
    useSelector((state) => state.bulkVerifyVisitForm) || [];

  const propconfig = useSelector((state) => state.propConfigurationList) || [];

  useEffect(() => {
    setForm(response);
    if (propconfig?.response?.data?.length > 0) {
      setPropertyConfig([propconfig?.response?.data[0]]);
    }
  }, [response, propconfig]);

  const handleNext = () => {
    if (!handleValid()) {
      dispatch(bulkVerifyVisitForm(form));
      let leadId = lead_id ? "?lead_id=" + lead_id : "";
      navigatpage("/createLeadnext1/" + _id + leadId);
    }
  };

  useEffect(() => {
    dispatch(getConfigurationPropList({ property_id: response?.property_id }));
  }, []);

  const handleInputField = (e) => {
    const nextFormState = {
      ...form,
      [e.target.name]: e.target.value,
    };
    setForm(nextFormState);
  };

  useLayoutEffect(() => {
    dispatch(getConfiguration());
  }, []);

  useEffect(() => {
    if (configurationsSelector.response) {
      const { response } = configurationsSelector;
      if (response?.status === 200) {
        setConfigurationsType(handleListResponse(response.data));
      } else {
        setConfigurationsType([]);
      }
    }
  }, [configurationsSelector]);

  const handleValid = () => {
    let err = {};
    let formError = false;
    if (
      form.min_budget &&
      form.max_budget &&
      (!form.min_budget_type || !form.max_budget_type)
    ) {
      formError = true;
      err["amountErr"] = strings.amountTypeErr;
    }
    if (
      form.min_emi_budget &&
      form.max_emi_budget &&
      (!form.min_emi_budget_type || !form.max_emi_budget_type)
    ) {
      formError = true;
      err["emiAmountErr"] = strings.amountTypeErr;
    }
    if (
      !minORmaxAmountValid(
        form.min_budget,
        form.max_budget,
        form.min_budget_type,
        form.max_budget_type
      )
    ) {
      formError = true;
      err["amountErr"] = strings.amountEror;
    }
    if (
      !minORmaxAmountEmiValid(
        form.min_emi_budget,
        form.max_emi_budget,
        form.min_emi_budget_type,
        form.max_emi_budget_type
      )
    ) {
      formError = true;
      err["emiAmountErr"] = strings.amountEror;
    }
    if (
      minORmaxValid(
        form.min_budget,
        form.max_budget,
      ) === 1
    ) {
      formError = true;
      err["amountErr"] = strings.amountMaxEror;
    }
    if (
      minORmaxValid(
        form.min_budget,
        form.max_budget,
      ) === 2
    ) {
      formError = true;
      err["amountErr"] = strings.amountMinEror;
    }
    if (
      minORmaxValid(
        form.min_emi_budget,
        form.max_emi_budget,
      ) === 1
    ) {
      formError = true;
      err["emiAmountErr"] = strings.amountMaxEmiEror;
    }
    if (
      minORmaxValid(
        form.min_emi_budget,
        form.max_emi_budget,
      ) === 2
    ) {
      formError = true;
      err["emiAmountErr"] = strings.amountMinEmiEror;
    }
    setFormVaild(err);
    return formError;
  };


  useEffect(() => {
    seo({
      title: "Create Visitor",
      metaDescription: "Create visitor",
      canonicalLink: window.location.href,
    });
  }, []);

  return (
    <div className="page-body">
      <Breadcrumb
        title={strings.createvisitor}
        url={"/verify_lead"}
        parentListing={strings.verifyListing}
        titleactive={strings.CreateVisitor}
        isBackBtn={true}
      />
      <div className="container-fluid">
        <div className="row ">
          <div className="col-sm-12 ">
            <div className="card">
              <div className="card-header pb-0">
                <h5>{strings.createvisitor}</h5>
              </div>
              <form className="form theme-form">
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-8">
                      <div className="mb-3">
                        <label htmlFor="exampleFormControlLastName">
                          {strings.configuration}
                        </label>
                        <select
                          className="form-control digits"
                          id="formcontrol-select1"
                          name="configuration_id"
                          value={form.configuration_id}
                          onChange={(e) => {
                            var index = e.nativeEvent.target.selectedIndex;
                            var configuration =
                              e.nativeEvent.target[index].text;
                            const nextFormState = {
                              ...form,
                              configuration_id: e.target.value,
                              configuration: configuration,
                            };
                            setForm(nextFormState);
                          }}
                        >
                          <option value={""}>
                            {strings.selectConfiguration}
                          </option>
                          {configurationsType.length > 0 ? (
                            configurationsType.map((item, i) => (
                              <option key={i} value={item._id}>
                                {item.title}
                              </option>
                            ))
                          ) : (
                            <option>{strings.Loading}</option>
                          )}
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-8">
                      <div className="mb-3">
                        <label htmlFor="exampleFormControlInput1">
                          {strings.expectedPossesionDate}
                        </label>
                        <input
                          className="form-control"
                          id="exampleFormControlInput1"
                          type="date"
                          name="expected_possession_date"
                          placeholder={strings.expectedPossesionDate}
                          value={form.expected_possession_date}
                          onChange={handleInputField}
                          min={moment().add(1, "days").format("yyyy-MM-DD")}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row ">
                    <div className="col-md-8">
                      <div className="mb-3">
                        <label htmlFor="exampleFormControlFirstName">
                          {strings.propertyType}
                        </label>
                        <select
                          className="form-control digits"
                          id="formcontrol-select1"
                          name="property_type"
                          value={form.property_type}
                          onChange={handleInputField}
                        >
                          <option defaultValue={null}>
                            {strings.selectPropType}
                          </option>
                          <option value={1}>{strings.moveIn}</option>
                          <option value={2}>{strings.underConstruction}</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-8">
                      <div className="mb-3">
                        <label htmlFor="exampleInputMobileNo">
                          {strings.Area}
                        </label>
                        <input
                          className="form-control"
                          id="exampleInputMobileNo"
                          type="number"
                          name="areain_sqlft"
                          autoComplete="off"
                          placeholder={strings.area}
                          value={form.areain_sqlft}
                          onChange={handleInputField}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12 row">
                      <div className="col-md-4">
                        <div className="mb-2">
                          <label htmlFor="exampleFormControlSelect9">
                            {strings.minBudget}
                          </label>
                          <div className="d-flex flex-direction-row">
                            <input
                              className="form-control digits"
                              id="exampleFormControlInput1"
                              type="number"
                              name="min_budget"
                              autoComplete="off"
                              value={form.min_budget}
                              onChange={(e) => {
                                handleInputField(e);
                                const err = minORmaxAmountValid(
                                  e.target.value,
                                  form.max_budget,
                                  form.min_budget_type,
                                  form.max_budget_type
                                );
                                if (e.target.value != "" && !err) {
                                  setFormVaild({
                                    ...formVaild,
                                    amountErr: strings.amountEror,
                                  });
                                } else {
                                  setFormVaild({
                                    ...formVaild,
                                    amountErr: null,
                                  });
                                }
                              }}
                              onKeyPress={(e) => {
                                if (e.target.value.length >= 4) {
                                  e.preventDefault();
                                }
                              }}
                            />
                            <select
                              id="exampleFormControlSelect9"
                              name="min_budget_type"
                              value={form.min_budget_type}
                              onChange={(e) => {
                                handleInputField(e);
                                const err = minORmaxAmountValid(
                                  form.min_budget,
                                  form.max_budget,
                                  e.target.value,
                                  form.max_budget_type
                                );
                                if (e.target.value != "" && !err) {
                                  setFormVaild({
                                    ...formVaild,
                                    amountErr: strings.amountEror,
                                  });
                                } else {
                                  setFormVaild({
                                    ...formVaild,
                                    amountErr: null,
                                  });
                                }
                              }}
                            >
                              <option value={""}>₹</option>
                              <option value={"L"}>L</option>
                              <option value={"C"}>Cr</option>
                            </select>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-4">
                        <div className="mb-2">
                          <label htmlFor="exampleFormControlSelect9">
                            {strings.maxBudget}
                          </label>
                          <div className="d-flex flex-direction-row">
                            <input
                              className="form-control digits"
                              id="exampleFormControlSelect9"
                              type="number"
                              name="max_budget"
                              value={form.max_budget}
                              onChange={(e) => {
                                handleInputField(e);
                                const err = minORmaxAmountValid(
                                  form.min_budget,
                                  e.target.value,
                                  form.min_budget_type,
                                  form.max_budget_type
                                );
                                if (e.target.value != "" && !err) {
                                  setFormVaild({
                                    ...formVaild,
                                    amountErr: strings.amountEror,
                                  });
                                } else {
                                  setFormVaild({
                                    ...formVaild,
                                    amountErr: null,
                                  });
                                }
                              }}
                              onKeyPress={(e) => {
                                if (e.target.value.length >= 4) {
                                  e.preventDefault();
                                }
                              }}
                            />
                            <select
                              id="exampleFormControlSelect9"
                              name="max_budget_type"
                              value={form.max_budget_type}
                              onChange={(e) => {
                                handleInputField(e);
                                const err = minORmaxAmountValid(
                                  form.min_budget,
                                  form.max_budget,
                                  form.min_budget_type,
                                  e.target.value
                                );
                                if (e.target.value != "" && !err) {
                                  setFormVaild({
                                    ...formVaild,
                                    amountErr: strings.amountEror,
                                  });
                                } else {
                                  setFormVaild({
                                    ...formVaild,
                                    amountErr: null,
                                  });
                                }
                              }}
                            >
                              <option value={""}>₹</option>
                              <option value={"L"}>L</option>
                              <option value={"C"}>Cr</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {formVaild?.amountErr && (
                    <span style={{ color: "red" }}>
                      {formVaild?.amountErr}
                    </span>
                  )}
                  <div className="row">
                    <div className="col-md-12 row">
                      <div className="col-md-4">
                        <div className="mb-2">
                          <label htmlFor="exampleFormControlSelect9">
                            {strings.minEMIpay}
                          </label>
                          <div className="d-flex flex-direction-row">
                            <input
                              className="form-control digits"
                              id="exampleFormControlInput1"
                              type="number"
                              name="min_emi_budget"
                              autoComplete="off"
                              value={form.min_emi_budget}
                              onChange={(e) => {
                                handleInputField(e);
                                const err = minORmaxAmountEmiValid(
                                  e.target.value,
                                  form.max_emi_budget,
                                  form.min_emi_budget_type,
                                  form.max_emi_budget_type
                                );
                                if (e.target.value != "" && !err) {
                                  setFormVaild({
                                    ...formVaild,
                                    emiAmountErr: strings.amountEror,
                                  });
                                } else {
                                  setFormVaild({
                                    ...formVaild,
                                    emiAmountErr: null,
                                  });
                                }
                              }}
                              onKeyPress={(e) => {
                                if (e.target.value.length >= 4) {
                                  e.preventDefault();
                                }
                              }}
                            />
                            <select
                              id="exampleFormControlSelect9"
                              name="min_emi_budget_type"
                              value={form.min_emi_budget_type}
                              onChange={(e) => {
                                handleInputField(e);
                                const err = minORmaxAmountEmiValid(
                                  form.min_emi_budget,
                                  form.max_emi_budget,
                                  e.target.value,
                                  form.max_emi_budget_type
                                );
                                if (e.target.value != "" && !err) {
                                  setFormVaild({
                                    ...formVaild,
                                    emiAmountErr: strings.amountEror,
                                  });
                                } else {
                                  setFormVaild({
                                    ...formVaild,
                                    emiAmountErr: null,
                                  });
                                }
                              }}
                            >
                              <option value={""}>₹</option>
                              <option value={"K"}>K</option>
                              <option value={"L"}>L</option>
                              <option value={"C"}>Cr</option>
                            </select>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-4">
                        <div className="mb-2">
                          <label htmlFor="exampleFormControlSelect9">
                            {strings.maxEMIpay}
                          </label>
                          <div className="d-flex flex-direction-row">
                            <input
                              className="form-control digits"
                              id="exampleFormControlSelect9"
                              type="number"
                              name="max_emi_budget"
                              value={form.max_emi_budget}
                              onChange={(e) => {
                                handleInputField(e);
                                const err = minORmaxAmountEmiValid(
                                  form.min_emi_budget,
                                  e.target.value,
                                  form.min_emi_budget_type,
                                  form.max_emi_budget_type
                                );
                                if (e.target.value != "" && !err) {
                                  setFormVaild({
                                    ...formVaild,
                                    emiAmountErr: strings.amountEror,
                                  });
                                } else {
                                  setFormVaild({
                                    ...formVaild,
                                    emiAmountErr: null,
                                  });
                                }
                              }}
                              onKeyPress={(e) => {
                                if (e.target.value.length >= 4) {
                                  e.preventDefault();
                                }
                              }}
                            />
                            <select
                              id="exampleFormControlSelect9"
                              name="max_emi_budget_type"
                              value={form.max_emi_budget_type}
                              onChange={(e) => {
                                handleInputField(e);
                                const err = minORmaxAmountEmiValid(
                                  form.min_emi_budget,
                                  form.max_emi_budget,
                                  form.min_emi_budget_type,
                                  e.target.value
                                );
                                if (e.target.value != "" && !err) {
                                  setFormVaild({
                                    ...formVaild,
                                    emiAmountErr: strings.amountEror,
                                  });
                                } else {
                                  setFormVaild({
                                    ...formVaild,
                                    emiAmountErr: null,
                                  });
                                }
                              }}
                            >
                              <option value={""}>₹</option>
                              <option value={"K"}>K</option>
                              <option value={"L"}>L</option>
                              <option value={"C"}>Cr</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {formVaild?.emiAmountErr && (
                    <span style={{ color: "red" }}>
                      {formVaild?.emiAmountErr}
                    </span>
                  )}
                  <div className="row pt-3">
                    <div className="col-md-8">
                      <div className="mb-4">
                        <label htmlFor="exampleFormControlLastName">
                          {strings.preferredBank}
                        </label>
                        <div className="col">
                          <div className="form-group m-t-15 m-checkbox-inline mb-0 custom-radio-ml">
                            <div className="radio radio-primary mr-5">
                              <input
                                id="radioinline24"
                                type="radio"
                                name="preferred_bank"
                                value={"Yes"}
                                checked={
                                  form.preferred_bank === "Yes" ? true : false
                                }
                                onChange={handleInputField}
                              />
                              <label className="mb-0" htmlFor="radioinline24">
                                {strings.yes}
                              </label>
                            </div>
                            <div className="radio radio-primary mr-5 ml-5">
                              <input
                                id="radioinline25"
                                type="radio"
                                name="preferred_bank"
                                value={"No"}
                                checked={
                                  form.preferred_bank === "No" ? true : false
                                }
                                onChange={handleInputField}
                              />
                              <label className="mb-0" htmlFor="radioinline25">
                                {strings.no}
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="mb-3">
                        <label htmlFor="exampleFormControlLastName1">
                          {strings.natureOffunding}
                        </label>
                        <div className="col">
                          <div className="form-group m-t-15 m-checkbox-inline mb-0 custom-radio-ml">
                            <div className="radio radio-primary ">
                              <input
                                id="radioinline1"
                                type="radio"
                                name="funding_type"
                                value={"loan"}
                                onChange={handleInputField}
                                checked={
                                  form.funding_type === "loan"
                                    ? true
                                    : false
                                }
                              />
                              <label className="mb-0" for="radioinline1">
                                {strings.loan}
                              </label>
                            </div>
                            <div className="radio radio-primary ml-5">
                              <input
                                id="radioinline2"
                                type="radio"
                                name="funding_type"
                                value={"self"}
                                checked={
                                  form.funding_type === "self"
                                    ? true
                                    : false
                                }
                                onChange={handleInputField}
                              />
                              <label className="mb-0" for="radioinline2">
                                {strings.selfFunding}
                              </label>
                            </div>
                            <div className="radio radio-primary ml-5">
                              <input
                                id="radioinline3"
                                type="radio"
                                name="funding_type"
                                value={"both"}
                                checked={
                                  form.funding_type === "both"
                                    ? true
                                    : false
                                }
                                onChange={handleInputField}
                              />
                              <label className="mb-0" for="radioinline3">
                                {strings.both}
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-8">
                      <div className="mb-3">
                        <label htmlFor="exampleFormControlLastName">
                          {strings.Purpose}
                        </label>
                        <div className="col">
                          <div className="form-group m-t-15 m-checkbox-inline mb-0 custom-radio-ml">
                            <div className="radio radio-primary mr-5">
                              <input
                                id="radioinline4"
                                type="radio"
                                name="purpose"
                                value={"end user"}
                                checked={
                                  form.purpose === "end user" ? true : false
                                }
                                onChange={handleInputField}
                              />
                              <label className="mb-0" for="radioinline4">
                                {strings.endUser}
                              </label>
                            </div>
                            <div className="radio radio-primary mr-5 ml-4">
                              <input
                                id="radioinline5"
                                type="radio"
                                name="purpose"
                                value={"invest"}
                                checked={
                                  form.purpose === "invest" ? true : false
                                }
                                onChange={handleInputField}
                              />
                              <label className="mb-0" for="radioinline5">
                                {strings.invesment}
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12 d-flex justify-content-end">
                      <div className="card-footer">
                        <button
                          className="btn btn-color"
                          type="button"
                          onClick={() => handleNext()}
                        >
                          {strings.next}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div >
    </div >
  );
};
export default CreateLeadNext;
